import React from 'react';
import {
  BooleanInput,
  Create,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

import { App, NotificationOptionValue } from '../../../graphql/types';
import EditToolbar from '../components/EditToolbar';

export const NotificationOptionCreate: React.FC = () => (
  <Create>
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="name" validate={required()} />
      <TextInput source="description" multiline rows={3} />
      <SelectInput
        source="app"
        choices={Object.entries(App).map(([name, value]) => ({
          id: value,
          name: name === 'Heart' ? 'Fit' : 'Perform',
        }))}
        validate={required()}
      />
      <NumberInput source="position" validate={required()} />
      <BooleanInput source="visible" defaultValue={true} />
      <SelectInput
        source="value"
        choices={Object.entries(NotificationOptionValue).map(
          ([name, value]) => ({
            id: value,
            name,
          }),
        )}
      />
      <TextInput source="featureFlag" label="Feature Flag" />
      <NumberInput source="iterableId" label="Iterable ID" />
    </SimpleForm>
  </Create>
);
